import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './workspace.scss';

function PageHeader({ actions, below, breadcrumbs, children, className, status, title, ...rest }) {
  return (
    <header className={classnames('page-header-workspace', className)} {...rest}>
      {breadcrumbs && (
        <nav aria-label="Breadcrumb" className="page-header-workspace__breadcrumbs">
          {breadcrumbs}
        </nav>
      )}
      <div className="page-header-workspace__row">
        <div className="page-header-workspace__identity">
          <div className="page-header-workspace__title-row">
            <h1 className="page-header-workspace__title">{title}</h1>
            {status && <div className="page-header-workspace__status">{status}</div>}
          </div>
          {children && <div className="page-header-workspace__supporting">{children}</div>}
        </div>
        {actions && <div className="page-header-workspace__actions">{actions}</div>}
      </div>
      {below && <div className="page-header-workspace__below">{below}</div>}
    </header>
  );
}

PageHeader.defaultProps = {
  actions: null,
  below: null,
  breadcrumbs: null,
  children: null,
  className: '',
  status: null,
  title: null
};

PageHeader.propTypes = {
  actions: PropTypes.node,
  below: PropTypes.node,
  breadcrumbs: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  status: PropTypes.node,
  title: PropTypes.node
};

export { PageHeader };
